import type { FlowInstanceStatus, FlowProcessStop } from "@repo/shared/types";

// Local translations — the factual line under the flow title. The stage
// NAME lives in components/flow/flow-stage-badge.tsx, shared with the
// client's Flows list.
export const T = {
  en_GB: {
    // Helper lines — what is happening and what comes next.
    helper: {
      draft: "Ready to edit. Complete the advice, then submit it.",
      in_progress: "Continue editing, then submit the advice.",
      submitted: "Submitted. Waiting for the documents to be generated.",
      pdf_generated: "Documents are ready. Continue the process in Process.",
      compliance_review: "Waiting for a compliance decision.",
      external_review: "Waiting for an external decision.",
      signing: "Waiting for signing. Manage the signing request in Process.",
      completed: "The process is complete. This advice is read-only.",
      cancelled: "This advice is cancelled. Its history is kept.",
    },
    // Stop lines — replace the helper while the process is stopped.
    stopped: {
      compliance_rejected: "Stopped — compliance rejected.",
      external_rejected: "Stopped — external review rejected.",
      cancelled: "Stopped — the advice was cancelled.",
      pdf_failed: "Stopped — the documents could not be generated. Retry in Process.",
      signing_failed: "Stopped — the signing request failed or expired. Retry in Process.",
    },
    // Appended to a stop line when the flow can be returned to editing.
    stoppedReopenHint: "Reopen to make changes.",
  },
  nb_NO: {
    helper: {
      draft: "Klar til redigering. Fullfør rådet og send det inn.",
      in_progress: "Fortsett redigeringen, og send deretter inn rådet.",
      submitted: "Sendt inn. Venter på at dokumentene genereres.",
      pdf_generated: "Dokumentene er klare. Fortsett prosessen i Prosess.",
      compliance_review: "Venter på beslutning fra compliance.",
      external_review: "Venter på ekstern beslutning.",
      signing: "Venter på signering. Administrer signeringsforespørselen i Prosess.",
      completed: "Prosessen er fullført. Dette rådet er skrivebeskyttet.",
      cancelled: "Dette rådet er kansellert. Historikken beholdes.",
    },
    stopped: {
      compliance_rejected: "Stoppet — compliance avviste.",
      external_rejected: "Stoppet — ekstern gjennomgang avviste.",
      cancelled: "Stoppet — rådet ble kansellert.",
      pdf_failed: "Stoppet — dokumentene kunne ikke genereres. Prøv igjen i Prosess.",
      signing_failed: "Stoppet — signeringsforespørselen feilet eller utløp. Prøv igjen i Prosess.",
    },
    stoppedReopenHint: "Gjenåpne for å gjøre endringer.",
  },
} as const satisfies Record<
  "en_GB" | "nb_NO",
  {
    helper: Record<FlowInstanceStatus, string>;
    stopped: Record<FlowProcessStop["reason"], string>;
    stoppedReopenHint: string;
  }
>;
